
const environment = window.location.href.split('/')[0];
const hostname = environment + '//' + window.location.hostname + '/EmailFiles'; //window.location.hostname
const stringDomain = '$domain$';

export function changeAttachmentsSrc(message){
    return message.map( element => element.replace(stringDomain, hostname));
}

export function changeMessageSrc(message){
    return message.replaceAll(stringDomain, hostname);
}



// WEBPACK FOOTER //
// ./src/js/helpers/helperMail.js